import { loader } from './LoaderBridge';

const originalFetch = global.fetch;

global.fetch = async (...args) => {
  loader.start();
  try {
    return await originalFetch(...args);
  } finally {
    loader.stop();
  }
};
